import { media } from '@styles/mediaQuery';
import styled from 'styled-components';

const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 40%;
  font-weight: 500;
  margin-bottom: 1vw;
  > h5 {
    margin-top: 7px;
    margin-right: 20px;
    font-size: 14px;
    strong {
      color: red;
    }
  }
  ${media.mobile`
    width: 50%;
  `}
`;

export default ToggleContainer;
